import type {Schemas} from 'domainTypes/dto';
import orderBy from 'lodash/orderBy';
import type {AgentName} from '../types';

export const mapNameVariantsDto = (
  dto: Schemas.AgentNameDto[],
): AgentName[] => {
  return orderBy(dto, ['nameOrder'], ['asc']).map(
    ({nameOrder: _, description, ...rest}) => ({
      ...rest,
      description: description ? description.trim() : undefined,
    }),
  );
};

export const mapToNameVariantsDto = (
  nameVariants: AgentName[],
): Schemas.AgentNameDto[] =>
  nameVariants.map(({description, ...rest}, idx) => ({
    ...rest,
    description: description ? description.trim() : undefined,
    nameOrder: idx,
  }));
